import React from "react";

const StatisticsDesktopHFM = () => {
  return (
    <div className="md:block hidden bg-[linear-gradient(90deg,#0f457e_-48.36%,#061a2f_47.32%,#0f457e_142.99%)] shadow-[0px_0px_2.667px_0px_rgba(0,0,0,0.25)] w-full md:py-12 py-10 z-20">
      <div className="lg:container mx-auto">
        <div className="flex md:justify-between md:flex-nowrap flex-wrap md:px-14">
          <div className="md:w-[30%] w-[100%] text-center">
            <p className="md:text-[42px] text-3xl font-medium text-white">
              70,000+
            </p>
            <p className="md:text-[21px] text-xl font-medium text-[#DCDCDC] md:mt-3 mt-1">
              Qualified Professionals
            </p>
          </div>

          <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
            <p className="md:text-[42px] text-3xl font-medium text-white">
              600+
            </p>
            <p className="md:text-[21px] text-xl font-medium text-[#DCDCDC] md:mt-3 mt-1">
              Corporate Partners
            </p>
          </div>

          <div className="md:w-[30%] w-[100%] text-center md:mt-0 mt-5">
            <p className="md:text-[42px] text-3xl font-medium text-white">
              100+
            </p>
            <p className="md:text-[21px] text-xl font-medium text-[#DCDCDC] md:mt-3 mt-1">
              University Partners
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsDesktopHFM;
